import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { IFilter } from '../../../interfaces/filter-config';
import { IMineZone } from '../../../interfaces/mine-zone';
import { FilterHandlerService } from '../../../services/filter/filter-handler.service';
import { GoogleAnalyticsService } from '../../../services/google/google-analytics.service';

@Component({
  selector: 'filter-mine',
  templateUrl: './filter-mine.component.html',
  styleUrls: ['./filter-mine.component.scss'],
})
export class FilterMineComponent implements AfterViewInit {
  @Input() public filter: IFilter;

  @Input() public set machineType(machineType: string) {
    if (machineType !== undefined) {
      this.getMinesByMachineType(String(machineType));
    }
  }

  @Output() public minesChanged: EventEmitter<IMineZone[]>;

  public mines: IMineZone[];

  public selectedOption: any;

  constructor(
    private filterHandlerService: FilterHandlerService,
    private cdr: ChangeDetectorRef,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this.mines = [];
    this.minesChanged = new EventEmitter<IMineZone[]>();
  }

  /**
   * App after view init
   */
  public ngAfterViewInit(): void {
    this.filterHandlerService.clearFilter$.subscribe(() => {
      if (!this.filter.uniqueSelection) {
        this.selectedOption = null;
      }
    });
  }

  /**
   * Function to change selected mine
   *
   * @param $event selected mine
   */
  public changeSelectedOption($event: any): void {
    this.minesChanged.emit($event);
    this.selectedOption = Array.isArray($event) ? $event : $event.zoneId;
    const filter = {
      filter_selected: 'filter_mine',
      value_selected: $event,
    };
    this.googleAnalyticsService.sendFilterEvent(filter);
  }

  /**
   * Function to get mines by machine type
   *
   * @param machineTypes Incoming machine type
   */
  public getMinesByMachineType(machineTypes: string): void {
    if (machineTypes.length > 0) {
      this.filterHandlerService.getAvailableMines(Number(machineTypes)).then(
        (mines: IMineZone[]) => {
          if (mines.length === 1) {
            this.filter = {
              required: true,
              uniqueSelection: {
                name: mines[0].name,
                zoneId: mines[0].zoneId,
                zoneTypeId: mines[0].zoneTypeId,
              },
            };

            this.mines = [this.filter.uniqueSelection];
            this.selectedOption = this.filter.uniqueSelection.zoneTypeId;
            this.changeSelectedOption(this.filter.uniqueSelection);
          }

          if (this.filter.uniqueSelection && mines.length === 1) {
            this.filter.uniqueSelection = mines[0];
          } else if (this.filter.multiselect) {
            for (const mine of mines) {
              (mine as any).selectedAllGroup = 'selectedAllGroup';
            }
          }

          this.mines = this.filter.uniqueSelection ? [mines[0]] : mines;

          if (this.filter.uniqueSelection) {
            this.changeSelectedOption(mines[0]);
          }

          this.cdr.detectChanges();
        },
        () => {},
      );
    } else {
      this.mines = [];
      this.cdr.detectChanges();
    }
  }
}
